<div
  [class.rounded-lg]="isLoading()"
  class="overflow-x-auto relative rounded-lg">
  @if (isLoading()) {
    <div class="flex flex-col grow min-h-[200px]">
      <app-skeleton />
    </div>
  } @else {
    <table class="min-w-full bg-white border border-text">
      <thead class="bg-[#E3EBF0] border-b border-text">
        <tr>
          @for (column of columns(); track column.id) {
            <th
              scope="col"
              class="px-2 py-3 text-left text-sm font-medium text-text border border-text"
              [style.width]="column.width">
              {{ column.label }}
            </th>
          }
        </tr>
      </thead>
      <tbody class="divide-y divide-text">
        @for (row of data(); track row['id']) {
          <tr class="hover:bg-gray-50">
            @for (column of columns(); track column.id) {
              <td
                class="px-2 py-3 whitespace-nowrap text-sm text-text border border-text"
                [style.width]="column.width">
                @if (column.id === 'actions' && actionsTemplate) {
                  <ng-container
                    [ngTemplateOutlet]="actionsTemplate"
                    [ngTemplateOutletContext]="{
                      $implicit: row,
                    }"></ng-container>
                } @else {
                  {{ row[column.id] }}
                }
              </td>
            }
          </tr>
        } @empty {
          <tr>
            <td
              [attr.colspan]="columns().length"
              class="px-6 py-4 text-center text-sm text-text">
              No data to display
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
